"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordToggler = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_icons_1 = require("@carvana/helios-icons");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var TextInput_1 = __importDefault(require("../TextInput/TextInput"));
var TextInput_styles_1 = require("../TextInput/TextInput.styles");
exports.PasswordToggler = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: none;\n  cursor: pointer;\n  position: absolute;\n  color: var(--cvna-color-blue-2);\n  font-size: 14px;\n  right: 16px;\n  bottom: 4px;\n\n  &:hover, &:focus {\n    display: block;\n  }\n"], ["\n  display: none;\n  cursor: pointer;\n  position: absolute;\n  color: var(--cvna-color-blue-2);\n  font-size: 14px;\n  right: 16px;\n  bottom: 4px;\n\n  &:hover, &:focus {\n    display: block;\n  }\n"])));
var PasswordInputContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & input {\n    padding-right: 49px;\n    & ~ ", " {\n      top: 8px;\n    }\n    &:hover ~ ", ", &:focus ~ ", " {\n      display: block;\n    }\n  }\n"], ["\n  & input {\n    padding-right: 49px;\n    & ~ ", " {\n      top: 8px;\n    }\n    &:hover ~ ", ", &:focus ~ ", " {\n      display: block;\n    }\n  }\n"])), TextInput_styles_1.IconContainer, exports.PasswordToggler, exports.PasswordToggler);
var PasswordInput = function (inputProps) {
    var value = inputProps.value, onChange = inputProps.onChange, minLength = inputProps.minLength;
    var _a = (0, react_1.useState)(value || ''), passwordState = _a[0], setPasswordState = _a[1];
    var _b = (0, react_1.useState)(false), showPassword = _b[0], setShowPassword = _b[1];
    var handlePasswordChange = function (e) {
        setPasswordState(e.target.value);
    };
    var togglePasswordHiddenState = function () {
        setShowPassword(!showPassword);
    };
    var textInputProps = __assign(__assign({}, inputProps), { minLength: minLength || 8, value: onChange ? value : passwordState, onChange: onChange || handlePasswordChange, type: showPassword ? "text" : "password" });
    return ((0, jsx_runtime_1.jsx)(PasswordInputContainer, { children: (0, jsx_runtime_1.jsx)(TextInput_1.default, __assign({}, textInputProps, { children: (0, jsx_runtime_1.jsx)(exports.PasswordToggler, __assign({ className: "password-toggler", onClick: togglePasswordHiddenState, "data-testid": "password-toggler" }, { children: showPassword ? (0, jsx_runtime_1.jsx)(helios_icons_1.EyeHide, { "data-testid": "eyehide" }) : (0, jsx_runtime_1.jsx)(helios_icons_1.EyeShow, { "data-testid": "eyeshow" }) })) })) }));
};
exports.default = PasswordInput;
var templateObject_1, templateObject_2;
